import LocalizationEntity from "../../../../../domain/entities/LocalizationEntity";
import LocalizationList from "./dictionaries/LocalizationList";

const GetCurrentLanguageApiImpl = async (keyStorage: string): Promise<LocalizationEntity> => {
    //load json in host/'localization/en.json
    try{
        const response = await fetch(`/localization/es.json`);
        const data = await response.json();
        return {
            code: 'es',
            dictionary: data,
            image: 'https://cdn.countryflags.com/thumbs/spain/flag-400.png',
            name: 'Spanish'	
        }
    }catch(e){
        return {
            code: 'es',
            dictionary: LocalizationList[0],
            image: 'https://cdn.countryflags.com/thumbs/spain/flag-400.png',
            name: 'Spanish'
        }
    }
}

export default GetCurrentLanguageApiImpl;